function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M20,7.24 L12.81,6.62 L10,0 L7.19,6.63 L0,7.24 L5.46,11.97 L3.82,19 L10,15.27 L16.18,19 L14.55,11.97 L20,7.24 Z M10,13.4 L10,4.1 L11.71,8.14 L16.09,8.52 L12.77,11.4 L13.77,15.68 L10,13.4 Z",
  id: "half_star_path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "rates/star/half_star",
  transform: "translate(-2.000000, -2.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_half_star",
  transform: "translate(2.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "half_star_mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#half_star_path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#F5A623",
  fillRule: "nonzero",
  xlinkHref: "#half_star_path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "UI-Color-/-Active-Color-",
  mask: "url(#half_star_mask-2)",
  fill: "#F5A623"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2.000000, -2.000000)",
  id: "Path"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "0 0 24 0 24 24 0 24"
}))))));

function SvgIconStarHalfYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarHalfYellow);
export default __webpack_public_path__ + "static/media/icon_star_half_yellow.109dbb41.svg";
export { ForwardRef as ReactComponent };